module.exports = __webpack_public_path__ + "static/media/african_heart.07aca7f5.jpg";